module.exports = __webpack_public_path__ + "img/laptop-settings.4273fa6d.png";